// useBusyToast — the busy answer's ONE toast (the fuse, ADR-079 §5): the
// person's own act met a full server. Wired here, where the words and the
// store are; apiClient only knows the slot (`setOnBusy`). Keyed, so a burst of
// busy answers never stacks — the newest words, one toast; it leaves by itself.
// RootLayout calls it once, above every frame.

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setOnBusy } from '../lib/apiClient.js';
import { useToastStore } from '../stores/toastStore.js';

export const BUSY_TOAST_KEY = 'busy';

export function useBusyToast(): void {
  const { t: tErrors } = useTranslation('errors');
  const addToast = useToastStore((s) => s.add);
  useEffect(() => {
    setOnBusy(() => addToast({ message: tErrors('BUSY'), variant: 'warning', key: BUSY_TOAST_KEY }));
    return () => setOnBusy(null);
  }, [addToast, tErrors]);
}
